"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _getColor = require("../../../../common/getColor");
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/arrow--right/24.js"));
var _DownloadLinkBox = require("../../DownloadLinkBox/DownloadLinkBox");
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-businessLinks {\n  display: flex;\n  flex-direction: column;\n  gap: 16px; }\n  .sia-businessLinks .sia-businessLink {\n    display: flex;\n    gap: 28px;\n    justify-content: space-between;\n    align-items: end; }\n  .sia-businessLinks a {\n    text-decoration: none; }\n\n@media (max-width: 42rem) {\n  .sia-businessLinks .sia-businessLink {\n    margin-inline: 16px; } }\n";
  const fileName = "BusinessLinks_BusinessLinks";
  const element = document.querySelector("style[data-sass-component='BusinessLinks_BusinessLinks']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Wrapper = _ref => {
  let {
    link,
    lang,
    section_element,
    children
  } = _ref;
  return link.url === link.original_url ? /*#__PURE__*/_react.default.createElement("a", {
    target: "_blank",
    href: link.url
  }, children) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: (0, _DownloadLinkBox.getInternalUrl)({
      link: {
        link: link,
        section_element: section_element
      },
      lang,
      isCMS: true
    }),
    style: {
      maxWidth: '100%'
    }
  }, children);
};
const BusinessLink = _ref2 => {
  let {
    businesslink_title,
    business_background_color,
    businesslink_description,
    businesslink_link,
    section_element,
    lang
  } = _ref2;
  const backgroundColor = business_background_color?.name ? (0, _getColor.getColor)(business_background_color?.name) : '';
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    link: businesslink_link,
    lang: lang,
    section_element: section_element
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-businessLink sia-padding-02",
    style: {
      backgroundColor
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "info"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-12",
    style: {
      color: backgroundColor !== business_background_color?.name ? 'white' : 'black'
    },
    dangerouslySetInnerHTML: {
      __html: businesslink_title
    }
  }), businesslink_description && /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-08 sia-margin-01-top",
    style: {
      color: backgroundColor !== business_background_color?.name ? 'white' : 'black'
    },
    dangerouslySetInnerHTML: {
      __html: businesslink_description
    }
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_.default, {
    style: {
      color: backgroundColor !== business_background_color?.name ? 'white' : 'black'
    }
  }))));
};
const BusinessLinks = _ref3 => {
  let {
    items,
    lang
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-businessLinks sia-margin-04-bottom"
  }, items.map((link, index) => {
    return /*#__PURE__*/_react.default.createElement(BusinessLink, _extends({
      key: index,
      lang: lang
    }, link));
  }));
};
var _default = exports.default = BusinessLinks;